export default __webpack_public_path__ + "static/preview-928029702a24f2f668a09c8b7de990ac.jpeg";